/* tslint:disable */
/* eslint-disable */
/**
 * NameCheck API
 * assembly version: 1.0.0.0
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PositionDropdownDto
 */
export interface PositionDropdownDto {
    /**
     * 
     * @type {number}
     * @memberof PositionDropdownDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PositionDropdownDto
     */
    name?: string | null;
}

export function PositionDropdownDtoFromJSON(json: any): PositionDropdownDto {
    return PositionDropdownDtoFromJSONTyped(json, false);
}

export function PositionDropdownDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PositionDropdownDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function PositionDropdownDtoToJSON(value?: PositionDropdownDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}


